module.exports = {
      id: "play-arrow-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg-sprite-58d03b3f1466f1d475a0d37264fe8fc2.svg#play-arrow",
      toString: function () {
        return this.url;
      }
    }